import { render, staticRenderFns } from "./outpatientVisit.vue?vue&type=template&id=609be746&scoped=true&"
import script from "./outpatientVisit.vue?vue&type=script&lang=js&"
export * from "./outpatientVisit.vue?vue&type=script&lang=js&"
import style0 from "./outpatientVisit.vue?vue&type=style&index=0&id=609be746&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609be746",
  null
  
)

export default component.exports